export enum PageMode {
	EDIT = 'edit',
	VIEW = 'view',
	LIVE = 'live',
}
